function getDataD3() {
  return [
    ['vitamin-d3-weight', $("input[name='vitamin-d3-weight']").val()],
    ['vitamin-d3-value', $("input[name='vitamin-d3-value']").val()],
    ['vitamin-d3-index', $('.radio-vitamin-d3-index-selected').attr('data-val')]
  ];
}

function calculateD3(data) {
  // Ladedosis (i.U.) = (((40 * (100 - Aktueller Vitamin D Wert)) * Körpergewicht in kg) / Tage)
  let result = (40 * (100 - data[1][1]) * data[0][1]) / data[2][1];

  result = Math.ceil(result / 2000);

  $('.vitamin-d3-result').text(result);
  $('.vitamin-d3-result-days').text(data[2][1]);

  $('.vitamin-d3-result-wrapper').removeClass('qlf-hidden');

  setTimeout(() => {
    $('.vitamin-d3-result-wrapper').addClass('qlf-opacity-100').removeClass('qlf-opacity-0');
  }, 400);

  $('html').animate(
    {
      scrollTop: $('.vitamin-d3-result-wrapper').offset().top - 100
    },
    800
  );
}

function validateFormD3() {
  let weight = $("input[name='vitamin-d3-weight']").val();
  let d3value = $("input[name='vitamin-d3-value']").val();
  let vitamind3index = $('.radio-vitamin-d3-index-selected').attr('data-val');
  let error = false;

  if (weight.length < 1) error = true;

  if (d3value.length < 1) error = true;

  if (vitamind3index === undefined) error = true;

  return error;
}

function checkD3() {
  let hasError = validateFormD3();
  if (!hasError) {
    $('.compute-vitamin-d3-supply').attr('disabled', false);
  } else {
    $('.compute-vitamin-d3-supply').attr('disabled', true);
  }
}

$(document).ready(function () {
  const $calculatorD3 = $('#vitamin-d3-calculator');

  if ($calculatorD3.length) {
    $('#vitamin-d3-calculator input').on('keyup', function () {
      let hasError = validateFormD3();
      if (!hasError) {
        $('.compute-vitamin-d3-supply').attr('disabled', false);
      } else {
        $('.compute-vitamin-d3-supply').attr('disabled', true);
      }
    });

    $('.compute-vitamin-d3-supply').click(function (e) {
      e.preventDefault();
      calculateD3(getDataD3());
    });

    $('.radio-btn-vitamin-d3-index').click(function (e) {
      e.preventDefault();
      if (!$(this).hasClass('radio-vitamin-d3-index-selected')) {
        $('.radio-btn-vitamin-d3-index').removeClass('radio-vitamin-d3-index-selected');
        $(this).addClass('radio-vitamin-d3-index-selected');
      }
      checkD3();
    });
  }
});
